import { render } from "./RefreshmentSharing.vue?vue&type=template&id=5ba99544&ts=true"
import script from "./RefreshmentSharing.vue?vue&type=script&lang=ts"
export * from "./RefreshmentSharing.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/t2_w86CdT/0/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__